module.exports = __webpack_public_path__ + "img/admin_adv_17.143d2d57.png";